// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/google.proto (syntax proto2)
/* eslint-disable */
import { fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
/**
 * Describes the file dxos/google.proto.
 */
export const file_dxos_google = /*@__PURE__*/ fileDesc("ChFkeG9zL2dvb2dsZS5wcm90b1AA", [file_google_protobuf_wrappers]);
//# sourceMappingURL=google_pb.js.map